// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-invite-user',
    templateUrl: './invite-user.component.html',
    styles: [
        `
            h2 {
                color: var(--white);
                text-align: center;
            }
        `,
    ],
})
export class InviteUserComponent {
    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly authService: AuthService
    ) {
        this.activatedRoute.params.subscribe((params) => {
            this.authService.registerUser(<any>params);
        });
    }
}
